import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import styles from "./styles.m.css";
import { Icon } from "../../atoms/icon";
import { DeepBI, WebEngage, EVOLOK } from "../../../integrations";
import { get } from "lodash";
import { btoa } from "isomorphic-base64";
import ResponsiveImageWithFallback from "../../atoms/responsive-image-with-fallback";

import { generateImageSources } from "../../utils/utils";
// import CompanionAd from "../../atoms/companian-ad-vast";

class AudioMagazinePlayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playing: false,
      currentTime: 0,
      duration: 0,
      volume: 1,
      shouldRender: false,
      showSpeedOptions: false,
      selectedSpeed: 1,
      currentStoryId: get(this.props, ["story"]),
      EVOLOKStoryId: get(this.props, ["story"]),
      EVOLOKStoryTitle: get(this.props, ["story", "headline"]),
      isAdPlaying: false,
      userType: "F",
      // userStatus: true,
      showLoginModal: false
    };
    this.initCallId = 0;
    this.audioRef = React.createRef();
    this.adContainerRef = React.createRef();
  }

  componentDidUpdate(prevProps, prevState) {
    const currentStory = get(this.props, ["CurrentStory"]);
    const collection = get(this.props, ["CurrentCollection"]);

    const currentStoryId = get(this.props, ["CurrentStory", "id"]);
    const prevStoryId = get(prevProps, ["CurrentStory", "id"]);
    const storyType = get(this.props, ["CurrentStory", "metadata", "story-attributes", "contenttype"]);

    // ✅ FIX: ClosePlayer just flipped false → player reopened after being closed
    // Re-initialize and play so the blocked init/play calls are recovered
    if (prevProps.ClosePlayer === true && this.props.ClosePlayer === false) {
      const magazineID = get(this.props, ["CurrentCollection", "id"]);
      if (this.props.enablePlayer && currentStoryId) {
        this.loadHlsScript()
          .then(() => this.initializePlayer(magazineID, currentStoryId, storyType))
          .then(() => {
            if (this.props.PlayAudio) {
              this.handlePlay(collection, currentStory, "reopen-after-close");
            }
          })
          .catch(err => console.error("[HLS] Reopen failed:", err));
      }
      return; // let this render settle, skip other checks this cycle
    }

    if (!this.props.ClosePlayer) {
      if (prevProps.enablePlayer !== this.props.enablePlayer && this.props.enablePlayer) {
        const magazineID = get(this.props, ["CurrentCollection", "id"]);
        const storyId = get(this.props, ["CurrentStory", "id"]);

        this.loadHlsScript()
          .then(() => this.initializePlayer(magazineID, storyId, storyType))
          .catch(err => console.error("[HLS] Failed:", err));
      }

      if (prevProps.PlayAudio !== this.props.PlayAudio) {
        const isStorySwitch = prevProps.CurrentStory !== this.props.CurrentStory && prevStoryId !== undefined;
        if (isStorySwitch) return;

        const magazine = get(this.props, ["CurrentCollection"]);
        const story = get(this.props, ["CurrentStory"]);
        this.props.PlayAudio ? this.handlePlay(magazine, story, "play-audio") : this.handlePause(magazine, story);
      }
    }

    if (prevStoryId !== undefined && currentStoryId !== undefined && currentStoryId !== prevStoryId) {
      const isAudiobook = storyType && storyType.includes("Audiobook");

      // ✅ AudioMagazine — skip EVOLOK, init and play directly
      if (!isAudiobook) {
        const latestMagazineID = get(this.props, ["CurrentCollection", "id"]);
        this.loadHlsScript()
          .then(() => this.initializePlayer(latestMagazineID, currentStoryId, storyType))
          .then(() => {
            if (this.props.PlayAudio) {
              this.handlePlay(collection, get(this.props, ["CurrentStory"]), "story-change");
            }
          })
          .catch(err => console.error("[HLS] Failed:", err));
        return;
      }

      // ✅ Audiobook — EVOLOK check required
      EVOLOK.loadScript("audio-page", { story: currentStory, collection }, response => {
        if (response.result === "ALLOW_ACCESS") {
          this.setState({ allow: true }, () => {
            const latestMagazineID = get(this.props, ["CurrentCollection", "id"]);
            const latestStoryType = get(this.props, ["CurrentStory", "metadata", "story-attributes", "contenttype"]);

            this.loadHlsScript()
              .then(() => this.initializePlayer(latestMagazineID, currentStoryId, latestStoryType))
              .then(() => {
                if (this.props.PlayAudio) {
                  this.handlePlay(collection, get(this.props, ["CurrentStory"]), "story-change");
                }
              })
              .catch(err => console.error("[HLS] Failed:", err));
          });
        } else {
          this.setState({ allow: false, playing: false });
          this.props.setAudioplaying(false);
          this.props.setMiniPlayerVisibility(false);
        }
      });
    }
  }
  loadHlsScript = () => {
    return new Promise((resolve, reject) => {
      // If Hls is already available, resolve immediately
      if (window.Hls) {
        resolve();
        return;
      }

      // Check if script is already appended
      const existing = document.querySelector('script[src*="hls.js"]');
      if (existing) {
        existing.onload = () => resolve();
        existing.onerror = () => reject(new Error("Failed to load Hls.js"));
        return;
      }

      // Append new script
      const script = document.createElement("script");
      script.src = "https://cdn.jsdelivr.net/npm/hls.js@latest";
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error("Failed to load Hls.js"));
      document.body.appendChild(script);
    });
  };

  initializePlayer = (magazineID, storyId, storyType) => {
    console.log("Initializing player with", { magazineID, storyId, storyType });
    const initId = ++this.initCallId;

    return new Promise((resolve, reject) => {
      if (this.hls) {
        this.hls.destroy();
      }

      const encodedMagazineID = btoa(magazineID);
      const audioUrl =
        storyType && storyType.includes("Audiobook")
          ? `https://audiomag.vikatan.com/audio-book/${encodedMagazineID}/${storyId}/${storyId}.m3u8`
          : `https://audiomag.vikatan.com/${encodedMagazineID}/${storyId}/${storyId}.m3u8`;

      if (window.Hls && window.Hls.isSupported()) {
        this.hls = new window.Hls();
        this.hls.loadSource(audioUrl);
        this.hls.attachMedia(this.audioRef.current);

        this.hls.on(window.Hls.Events.MANIFEST_PARSED, () => {
          if (initId !== this.initCallId) return; // ✅ stale call, bail
          this.audioRef.current.playbackRate = this.state.selectedSpeed;
          resolve();
        });

        this.hls.on(window.Hls.Events.ERROR, (event, data) => {
          if (data.fatal && initId === this.initCallId) {
            reject(data);
          }
        });
      } else if (this.audioRef.current.canPlayType("application/vnd.apple.mpegurl")) {
        this.audioRef.current.src = audioUrl;
        this.audioRef.current.playbackRate = this.state.selectedSpeed;
        this.audioRef.current.oncanplay = () => {
          if (initId !== this.initCallId) return; // ✅ stale call, bail
          resolve();
        };
        this.audioRef.current.load();
      } else {
        reject(new Error("HLS not supported"));
      }
    });
  };

  componentWillUnmount() {
    if (this.hls) {
      this.hls.destroy();
    }
  }

  handlePlay = (magazine, story, source) => {
    const storyType = get(story, ["metadata", "story-attributes", "contenttype"]);
    const audioElement = this.audioRef.current;

    if (!audioElement) return;

    const isAudiobook = storyType && storyType.includes("Audiobook");
    const isResumed = audioElement.currentTime > 0;

    const playEventName = isAudiobook
      ? isResumed
        ? "audiobookresumed"
        : "audiobookplayed"
      : isResumed
        ? "audiomagazineresumed"
        : "audiomagazineplayed";

    const playPromise = audioElement.play();

    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          // Playback successful
          this.setState({
            playing: true,
            currentTime: audioElement.currentTime
          });

          this.props.setAudioplaying(true);

          WebEngage.Webplayer(story, playEventName, magazine);
          DeepBI.PingAudioplayer(story, playEventName, magazine, this.formatSecondsTime(audioElement.currentTime));
        })
        .catch(error => {
          console.error("Playback error:", error);

          audioElement.pause();
          audioElement.currentTime = 0;

          this.setState({ playing: false });
          this.props.setAudioplaying(false);
        });
    }
  };

  handlePause = (magazine, story) => {
    const storyType = get(story, ["metadata", "story-attributes", "contenttype"]);

    // Determine the event name based on story type
    const pauseEventName = storyType && storyType.includes("Audiobook") ? "audiobookpaused" : "audiomagazinepaused";
    if (this.audioRef && this.audioRef.current) {
      this.audioRef && this.audioRef.current.pause();
    }
    this.props.setAudioplaying(false);
    this.setState({ playing: false, currentTime: this.audioRef.current.currentTime });
    DeepBI.PingAudioplayer(story, pauseEventName, magazine, this.formatSecondsTime(this.audioRef.current.currentTime));
    WebEngage.Webplayer(story, pauseEventName, magazine);
  };

  // handlePause = (magazine, story) => {
  //   const audioElement = this.audioRef && this.audioRef.current;

  //   // ✅ Don't fire pause event if audio was never actually playing
  //   if (!this.state.playing && (!audioElement || audioElement.paused)) return;

  //   const storyType = get(story, ["metadata", "story-attributes", "contenttype"]);
  //   const pauseEventName = storyType && storyType.includes("Audiobook") ? "audiobookpaused" : "audiomagazinepaused";

  //   if (audioElement) {
  //     audioElement.pause();
  //   }

  //   this.props.setAudioplaying(false);
  //   this.setState({ playing: false, currentTime: audioElement ? audioElement.currentTime : 0 });
  //   DeepBI.PingAudioplayer(
  //     story,
  //     pauseEventName,
  //     magazine,
  //     this.formatSecondsTime(audioElement ? audioElement.currentTime : 0)
  //   );
  //   WebEngage.Webplayer(story, pauseEventName, magazine);
  // };

  handleTimeUpdate = () => {
    this.setState({
      currentTime: this.audioRef.current.currentTime,
      duration: this.audioRef.current.duration
    });
  };

  setFinished = () => {
    const storyType = get(this.props, ["CurrentStory", "metadata", "story-attributes", "contenttype"]);

    // Determine the event name based on story type
    const pauseEventName =
      storyType && storyType.includes("Audiobook") ? "audiobookcompleted" : "audiomagazinecompleted";
    this.setState({
      playing: false,
      currentTime: 0
    });
    this.props.setAudioplaying(this.props.PlayAudio);
    DeepBI.PingAudioplayer(
      get(this.props, ["CurrentStory"]),
      pauseEventName,
      get(this.props, ["CurrentCollection"]),
      this.formatSecondsTime(this.audioRef.current.currentTime)
    );
    WebEngage.Webplayer(get(this.props, ["CurrentStory"]), pauseEventName, get(this.props, ["CurrentCollection"]));
    this.handleNext();
  };

  handleVolumeChange = e => {
    this.setState({ volume: e.target.value });
    this.audioRef.current.volume = e.target.value;
  };

  handleSeek = e => {
    this.audioRef.current.currentTime = e.target.value;
  };

  handleSpeedChange = speed => {
    const storyType = get(this.props, ["CurrentStory", "metadata", "story-attributes", "contenttype"]);

    // Determine the event name based on story type
    const pauseEventName = storyType && storyType.includes("Audiobook") ? "audiobookspeed" : "audiomagazinespeed";
    const speeds = [1, 1.2, 1.5];
    const currentIndex = speeds.indexOf(speed);
    const newSpeed = currentIndex === speeds.length - 1 ? speeds[0] : speeds[currentIndex + 1];

    this.audioRef.current.playbackRate = newSpeed;
    this.setState({ selectedSpeed: newSpeed });

    // Logging events
    WebEngage.Webplayer(get(this.props, ["CurrentStory"]), pauseEventName, get(this.props, ["CurrentCollection"]));
    DeepBI.PingAudioplayer(
      get(this.props, ["CurrentStory"]),
      pauseEventName,
      get(this.props, ["CurrentCollection"]),
      this.formatSecondsTime(this.audioRef.current.currentTime)
    );
  };

  formatTime = time => {
    const timeNum = Number(time);
    if (isNaN(timeNum)) return "00:00";

    const hours = Math.floor(timeNum / 3600);
    const remainder = timeNum % 3600;
    const minutes = Math.floor(remainder / 60);
    const seconds = Math.floor(remainder % 60);

    const hh = hours > 0 ? `${hours.toString().padStart(2, "0")}:` : "";
    const mm = minutes.toString().padStart(2, "0");
    const ss = seconds.toString().padStart(2, "0");

    return `${hh}${mm}:${ss}`;
  };

  formatSecondsTime = time => {
    const remainder = time % 3600;
    const minutes = Math.floor(remainder / 60);
    const seconds = Math.floor(remainder % 60);

    const mm = minutes.toString().padStart(2, "0");
    const ss = seconds.toString().padStart(2, "0");

    return parseInt(mm) * 60 + parseInt(ss);
  };

  skip = time => {
    const storyType = get(this.props, ["CurrentStory", "metadata", "story-attributes", "contenttype"]);

    if (time === "back") {
      // Determine the event name based on story type
      let pauseEventName =
        storyType && storyType.includes("Audiobook") ? "audiobookseekbackword" : "audiomagazineseekbackword";
      this.audioRef.current.currentTime = this.audioRef.current.currentTime - 15;
      WebEngage.Webplayer(get(this.props, ["CurrentStory"]), pauseEventName, get(this.props, ["CurrentCollection"]));
      DeepBI.PingAudioplayer(
        get(this.props, ["CurrentStory"]),
        pauseEventName,
        get(this.props, ["CurrentCollection"]),
        this.formatSecondsTime(this.audioRef.current.currentTime)
      );
    } else if (time === "fwd") {
      let pauseEventNameFwd =
        storyType && storyType.includes("Audiobook") ? "audiobookseekforward" : "audiomagazineseekforward";
      this.audioRef.current.currentTime = this.audioRef.current.currentTime + 15;
      WebEngage.Webplayer(get(this.props, ["CurrentStory"]), pauseEventNameFwd, get(this.props, ["CurrentCollection"]));

      DeepBI.PingAudioplayer(
        get(this.props, ["CurrentStory"]),
        pauseEventNameFwd,
        get(this.props, ["CurrentCollection"]),
        this.formatSecondsTime(this.audioRef.current.currentTime)
      );
    }
  };

  handleNext = () => {
    if (this.hls) {
      this.hls.destroy();
    }
    const stories = get(this.props, ["CurrentCollection", "items"] || []);

    const currentStoryId = get(this.props, ["CurrentStory", "id"]);
    // const magazineID = get(this.props, ["data", "issueCollection", "id"]);

    const currentStoryIndex = stories.findIndex(story => story.id === currentStoryId);

    if (currentStoryIndex === -1 || stories.length === 0) return; // No valid current story

    const storiesCount = stories.length;
    const nextIndex = (currentStoryIndex + 1) % storiesCount;
    const nextStory = stories[nextIndex];

    // Check if next story has audio available
    const audioAvailable = get(nextStory, ["story", "metadata", "story-attributes", "audiolength"], 0);
    const storyType = get(this.props, ["CurrentStory", "metadata", "story-attributes", "contenttype"]);

    if ((storyType && storyType !== undefined && storyType.includes("Audiobook")) || audioAvailable > 0) {
      const pauseEventName = storyType && storyType.includes("Audiobook") ? "audiobooknext" : "audiomagazinenext";
      // console.log("audio-available");
      //   this.initializePlayer(magazineID, get(nextStory, ["story", "id"]));
      //  this.handlePlay(get(this.props, ["data", "issueCollection"]), get(nextStory, ["story"]));
      WebEngage.Webplayer(get(nextStory, ["story"]), pauseEventName, get(this.props, ["data", "issueCollection"]));
      DeepBI.PingAudioplayer(get(nextStory, ["story"]), pauseEventName, get(this.props, ["CurrentCollection"]));
      this.props.setCurrentStory(get(nextStory, ["story"]));
      // this.props.setAudioplaying(this.props.PlayAudio);
      this.setState({
        currentTime: 0,
        EVOLOKStoryId: get(nextStory, ["story", "id"]),
        EVOLOKStoryTitle: get(nextStory, ["story", "headline"])
      });

      // this.setState({ currentStoryId: get(nextStory, ["story"]) });
    } else {
      console.log("audio- not available", currentStoryId);
    }
  };

  handlePrev = () => {
    if (this.hls) {
      this.hls.destroy();
    }
    const stories = get(this.props, ["CurrentCollection", "items"] || []);
    const currentStoryId = get(this.props, ["CurrentStory", "id"]);
    // const magazineID = get(this.props, ["data", "issueCollection", "id"]);

    if (stories.length === 0) return; // No stories available

    const currentStoryIndex = stories.findIndex(story => story.id === currentStoryId);
    if (currentStoryIndex === -1) return; // No valid current story

    const prevIndex = (currentStoryIndex - 1 + stories.length) % stories.length;
    const prevStory = stories[prevIndex];

    // Check if previous story has audio available
    const audioAvailable = get(prevStory, ["story", "metadata", "story-attributes", "audiolength"], 0);
    const storyType = get(this.props, ["CurrentStory", "metadata", "story-attributes", "contenttype"]);

    if ((storyType && storyType !== undefined && storyType.includes("Audiobook")) || audioAvailable > 0) {
      const pauseEventName =
        storyType && storyType.includes("Audiobook") ? "audiobookprevious" : "audiomagazineprevious";

      //  console.log("Audio available for the previous story");
      //  this.initializePlayer(magazineID, get(prevStory, ["story", "id"]));
      // this.handlePlay(get(this.props, ["data", "issueCollection"]), get(prevStory, ["story"]));
      this.props.setCurrentStory(get(prevStory, ["story"]));
      // this.props.setAudioplaying(this.props.PlayAudio);
      this.setState({
        currentTime: 0,
        EVOLOKStoryId: get(prevStory, ["story", "id"]),
        EVOLOKStoryTitle: get(prevStory, ["story", "headline"])
      });

      WebEngage.Webplayer(get(prevStory, ["story"]), pauseEventName, get(this.props, ["CurrentCollection"]));
      DeepBI.PingAudioplayer(get(prevStory, ["story"]), pauseEventName, get(this.props, ["CurrentCollection"]));
    } else {
      console.log("Audio not available for the previous story", prevStory.id);
      // Optionally, you can call handlePrev recursively to skip stories without audio
      // this.handlePrev();
    }
  };

  closeMiniPlayer = () => {
    const storyType = get(this.props, ["CurrentStory", "metadata", "story-attributes", "contenttype"]);

    const pauseEventName =
      storyType && storyType.includes("Audiobook") ? "audiobookminiplayerclosed" : "audiomagazineminiplayerclosed";

    WebEngage.Webplayer(get(this.props, ["CurrentStory"]), pauseEventName, get(this.props, ["CurrentCollection"]));
    DeepBI.PingAudioplayer(
      get(this.props, ["CurrentStory"]),
      pauseEventName,
      get(this.props, ["CurrentCollection"]),
      this.formatSecondsTime(this.audioRef.current.currentTime)
    );
    if (this.audioRef && this.audioRef.current) {
      this.audioRef.current.pause();
      this.audioRef.current.currentTime = 0;
      if (this.hls) {
        this.hls.destroy();
        this.hls = null;
      }
      this.audioRef.current.src = ""; // Reset the src to ensure proper reinitialization
      this.props.setMiniPlayerVisibility(false);
      this.props.setAudioplaying(false);
      this.props.setClosePlayer(true);
      this.props.setCurrentStory(null);
      this.setState({ selectedSpeed: 1, playing: false });
    }
  };

  handleShare = () => {
    const currentStoryslug = get(this.props, ["CurrentStory", "slug"]);

    const magazineID = get(this.props, ["CurrentCollection", "id"]);

    const domainName = global && global.location && global.location.origin;

    const currentUrl = `${domainName}/vikatan-play/${magazineID}/${currentStoryslug}`;

    // Copy URL to clipboard
    navigator.clipboard
      .writeText(currentUrl)
      .then(() => {
        console.log("Link copied to clipboard!"); // Notify the user
      })
      .catch(err => {
        console.error("Failed to copy URL: ", err);
      });

    // Optional: Open native share dialog (only for mobile & supported browsers)
    if (navigator.share) {
      navigator
        .share({
          title: document.title,
          url: currentUrl
        })
        .then(() => console.log("Shared successfully"))
        .catch(err => console.error("Error sharing: ", err));
    }
  };
  render() {
    const { playing, currentTime, duration, selectedSpeed, EVOLOKStoryId, EVOLOKStoryTitle } = this.state;
    const { enablePlayer } = this.props;

    const storyHeadline = get(this.props, ["CurrentStory", "headline"], () => null);
    const storyImage = get(this.props, ["CurrentStory", "hero-image-s3-key"], () => null);
    const AudioStoryId = get(this.props, ["CurrentStory", "id"]);

    if (!enablePlayer) {
      return <div className="no audio found" />;
    }

    // ✅ Shared play/pause handler with correct args
    const handlePlayPauseClick = () => {
      const magazine = get(this.props, ["CurrentCollection"]);
      const story = get(this.props, ["CurrentStory"]);
      playing ? this.handlePause(magazine, story) : this.handlePlay(magazine, story, "test1");
    };

    return (
      <div
        className={`js-story-main-container-${EVOLOKStoryId}  js-story-main-title-${EVOLOKStoryTitle}  ${`${
          styles["main-container"]
        }`}}`}
      >
        {" "}
        {/* ✅ Single audio element — outside both desktop/mobile layouts */}
        <audio
          id={`audio-${AudioStoryId}`}
          ref={this.audioRef}
          onTimeUpdate={this.handleTimeUpdate}
          onEnded={this.setFinished}
          preload="none"
        />
        <div className={styles["new-audio-player-wrapper"]} id="play-button">
          <div className={styles["mini-player-toggle"]} onClick={this.closeMiniPlayer}>
            <Icon type="close" className={styles["mini-player-close-icon"]} />
          </div>
          <div className={styles["audio-player-wrapper"]}>
            <div>
              <div className={styles["mini-player-controls"]}>
                <div>
                  {/* ===== DESKTOP ===== */}
                  <div className={`${styles["audio-controls"]} hidden-mobile`}>
                    <div className={styles["audio-header"]}>
                      {storyImage && (
                        <ResponsiveImageWithFallback
                          className={styles["image-wrapper"]}
                          slug={storyImage}
                          metadata={{}}
                          alt={storyHeadline}
                          imgParams={{ auto: ["format", "compress"] }}
                          sources={generateImageSources(
                            { aspectRatio: [4, 3], screenWidthCoverage: 0.34 },
                            { aspectRatio: [4, 3], screenWidthCoverage: 0.12 }
                          )}
                        />
                      )}
                    </div>
                    {storyHeadline && <h2 className={styles["audio-headline"]}>{storyHeadline}</h2>}
                    <div className={styles["audio-marquee"]}>
                      <div className={`${styles["audio-controls-grid"]}`}>
                        <div className={styles["audio-controls-icons"]}>
                          <div className={`${styles["audio-control-icons"]}`} onClick={this.handlePrev}>
                            <Icon type="icon-audio-previous" className={`${styles["audio-icon"]}`} />
                          </div>
                          <div
                            onClick={() => this.skip("back")}
                            className={`${styles["fast-backward-outer"]} ${styles["audio-control-icons"]}`}
                          >
                            <Icon type="backward" className={`${styles["fast-backward"]} ${styles["audio-icon"]}`} />
                          </div>
                          {/* ✅ Fixed — using shared handler with correct args */}
                          <div className={`${styles["audio-control-icons"]}`} onClick={handlePlayPauseClick}>
                            {playing ? (
                              <Icon type="pause" className={`${styles["pause"]} ${styles["audio-icon"]}`} />
                            ) : (
                              <Icon type="play" className={`${styles["play"]} ${styles["audio-icon"]}`} />
                            )}
                          </div>
                          <div
                            onClick={() => this.skip("fwd")}
                            className={`${styles["fast-forward-outer"]} ${styles["audio-control-icons"]}`}
                          >
                            <Icon type="forward" className={`${styles["fast-forward"]} ${styles["audio-icon"]}`} />
                          </div>
                          <div className={`${styles["audio-control-icons"]}`} onClick={this.handleNext}>
                            <Icon type="icon-audio-next" className={`${styles["audio-icon"]}`} />
                          </div>
                        </div>
                        <div className={styles["audio-controls-top-section"]}>
                          <div className={styles["progress-bar"]}>
                            <input
                              type="range"
                              min={0}
                              max={duration}
                              step={0.01}
                              value={currentTime}
                              onChange={this.handleSeek}
                              className={styles["progress"]}
                            />
                          </div>
                          <div className={styles["audio-in-out-time"]}>
                            <div className={styles["audio-text"]}>{this.formatTime(currentTime)}</div>
                            <div className={styles["audio-text"]}>{this.formatTime(duration)}</div>
                          </div>
                        </div>
                        <div className={styles["audio-controls-bottom-section"]}>
                          <div className={styles["audio-controls-speed"]}>
                            <ul className={styles["speed-list"]}>
                              {[1, 1.2, 1.5].map(
                                speed =>
                                  selectedSpeed === speed && (
                                    <li key={speed} onClick={() => this.handleSpeedChange(speed)}>
                                      {speed}x
                                    </li>
                                  )
                              )}
                            </ul>
                            <div className="hidden-mobile">Speed</div>
                            <div onClick={this.handleShare}>
                              <Icon type="icon-share" className={`${styles["share-icon"]}`} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* ===== MOBILE ===== */}
                  <div className={`${styles["audio-controls"]} hidden-desktop`}>
                    <div className={styles["audio-header"]}>
                      {storyImage && (
                        <ResponsiveImageWithFallback
                          className={styles["image-wrapper"]}
                          slug={storyImage}
                          metadata={{}}
                          alt={storyHeadline}
                          imgParams={{ auto: ["format", "compress"] }}
                          sources={generateImageSources(
                            { aspectRatio: [4, 3], screenWidthCoverage: 0.34 },
                            { aspectRatio: [4, 3], screenWidthCoverage: 0.12 }
                          )}
                        />
                      )}
                    </div>
                    <div className={styles["audio-marquee"]}>
                      <marquee>
                        {storyHeadline && <h2 className={styles["audio-headline"]}>{storyHeadline}</h2>}
                      </marquee>
                      <div className={styles["audio-controls-top-section"]}>
                        <div className={styles["progress-bar"]}>
                          <input
                            type="range"
                            min={0}
                            max={duration}
                            step={0.01}
                            value={currentTime}
                            onChange={this.handleSeek}
                            className={styles["progress"]}
                          />
                        </div>
                        <div className={styles["audio-in-out-time"]}>
                          <div className={styles["audio-text"]}>{this.formatTime(currentTime)}</div>
                          <div className={styles["audio-text"]}>{this.formatTime(duration)}</div>
                        </div>
                      </div>
                    </div>
                    <div className={`${styles["audio-controls-grid"]}`} id="play-button">
                      <div className={styles["audio-controls-icons"]}>
                        <div className={`${styles["audio-control-icons"]}`} onClick={this.handlePrev}>
                          <Icon type="icon-audio-previous" className={`${styles["audio-icon"]}`} />
                        </div>
                        <div
                          onClick={() => this.skip("back")}
                          className={`${styles["fast-backward-outer"]} ${styles["audio-control-icons"]}`}
                        >
                          <Icon type="backward" className={`${styles["fast-backward"]} ${styles["audio-icon"]}`} />
                        </div>
                        {/* ✅ Fixed — using shared handler with correct args */}
                        <div className={`${styles["audio-control-icons"]}`} onClick={handlePlayPauseClick}>
                          {playing ? (
                            <Icon type="pause" className={`${styles["pause"]} ${styles["audio-icon"]}`} />
                          ) : (
                            <Icon type="play" className={`${styles["play"]} ${styles["audio-icon"]}`} />
                          )}
                        </div>
                        <div
                          onClick={() => this.skip("fwd")}
                          className={`${styles["fast-forward-outer"]} ${styles["audio-control-icons"]}`}
                        >
                          <Icon type="forward" className={`${styles["fast-forward"]} ${styles["audio-icon"]}`} />
                        </div>
                        <div className={`${styles["audio-control-icons"]}`} onClick={this.handleNext}>
                          <Icon type="icon-audio-next" className={`${styles["audio-icon"]}`} />
                        </div>
                        <div className={styles["audio-controls-bottom-section"]}>
                          <div className={styles["audio-controls-speed"]}>
                            <ul className={styles["speed-list"]}>
                              {[1, 1.2, 1.5].map(
                                speed =>
                                  selectedSpeed === speed && (
                                    <li key={speed} onClick={() => this.handleSpeedChange(speed)}>
                                      {speed}x
                                    </li>
                                  )
                              )}
                            </ul>
                            <div className="hidden-mobile">Speed</div>
                            <div onClick={this.handleShare} className={`${styles["mobile-share"]}`}>
                              <Icon type="icon-share" className={`${styles["share-icon"]}`} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AudioMagazinePlayer.propTypes = {
  story: PropTypes.object.isRequired,
  storyImage: PropTypes.string,
  storyHeadline: PropTypes.string,
  id: PropTypes.string,
  playState: PropTypes.bool.isRequired,
  setMiniPlayerVisibility: PropTypes.bool.isRequired,
  enablePlayer: PropTypes.bool.isRequired,
  PlayAudio: PropTypes.bool.isRequired,
  setAudioplaying: PropTypes.bool.isRequired,
  setCurrentStory: PropTypes.object,
  ClosePlayer: PropTypes.bool.isRequired,
  setClosePlayer: PropTypes.bool.isRequired,
  CurrentStory: PropTypes.object,
  CurrentCollection: PropTypes.object
};

function mapStateToProps(state) {
  return {
    data: get(state, ["qt", "data"]),
    enablePlayer: get(state, ["ShowPlayer"]),
    PlayAudio: get(state, ["PlayAudio"]),
    story: get(state, ["qt", "data", "story"], () => null),
    CurrentStory: get(state, ["CurrentStory"]),
    ClosePlayer: get(state, ["ClosePlayer"]),
    CurrentCollection: get(state, ["CurrentCollection"])
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setMiniPlayerVisibility: function(isVisible) {
      dispatch({
        type: "SET_MINI_PLAYER_VISIBILITY",
        payload: isVisible
      });
    },
    setAudioplaying: isVisible => {
      dispatch({
        type: "AUDIO_PLAYING",
        payload: isVisible
      });
    },
    setCurrentStory: story => {
      dispatch({
        type: "CURRENT_STORY",
        payload: story
      });
    },
    setClosePlayer: isVisible => {
      dispatch({
        type: "CLOSE_PLAYER",
        payload: isVisible
      });
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AudioMagazinePlayer);
